import { MessageInterface } from '../../interfaces/components/http-client/message.interface';

export abstract class Message implements MessageInterface {
  private readonly headers: Headers;
  private uri: URL;

  protected constructor (uri: URL | string, headers?: RequestInit['headers']) {
    this.uri = uri instanceof URL ? uri : new URL(uri);
    this.headers = new Headers(headers);
  }

  public getHeaders (): Headers {
    return this.headers;
  }

  public hasHeader (header: string): boolean {
    return this.headers.has(header.toLowerCase());
  }

  public withHeader (header: string, value: string | string[]): MessageInterface {
    value = Array.isArray(value) ? value : [ value ];

    for (const innerValue of value) {
      this.headers.set(header.toLowerCase(), innerValue);
    }

    return this;
  }

  public withAddedHeader (header: string, value: string | string[]): MessageInterface {
    value = Array.isArray(value) ? value : [ value ];

    for (const innerValue of value) {
      this.headers.append(header.toLowerCase(), innerValue);
    }

    return this;
  }

  public withoutHeader (header: string): MessageInterface {
    this.headers.delete(header.toLowerCase());

    return this;
  }

  public getUri (): URL {
    return this.uri;
  }

  public withUri (uri: URL): MessageInterface {
    this.uri = uri;
    return this;
  }
}
